const generalTheme = {
  borderRadius: '8px',
  boxShadow: {
    base: ' 0 0 20px 0 rgba(0,0,0,0.07), 0 2px 12px rgba(0,0,0,0.14);',
  },
};

export default generalTheme;
